import { useSessionsQueryActions } from 'features/sessions/hooks/useSessionsQueryActions';

export const useLatestSessionId = () => {
  const { getSessionList } = useSessionsQueryActions();

  const latestSession = getSessionList()?.[0];

  return latestSession?.coachingSessionId;
};
